// Fly-to-cart: a ghost thumbnail arcs from the product image to the header cart icon.
export function flyToCart(sourceEl, imgSrc) {
  try {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const target = document.querySelector('[data-testid="header-cart-icon"]');
    if (!sourceEl || !target || !imgSrc) return;

    const s = sourceEl.getBoundingClientRect();
    const t = target.getBoundingClientRect();
    if (!s.width || !t.width) return;

    const ghost = document.createElement('img');
    ghost.src = imgSrc;
    Object.assign(ghost.style, {
      position: 'fixed',
      left: `${s.left}px`,
      top: `${s.top}px`,
      width: `${s.width}px`,
      height: `${s.height}px`,
      objectFit: 'cover',
      borderRadius: '10px',
      zIndex: '130',
      pointerEvents: 'none',
      boxShadow: '0 12px 44px rgba(0,0,0,0.45)',
      willChange: 'transform, opacity',
    });
    document.body.appendChild(ghost);

    const dx = (t.left + t.width / 2) - (s.left + s.width / 2);
    const dy = (t.top + t.height / 2) - (s.top + s.height / 2);

    const anim = ghost.animate(
      [
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 90}px) scale(0.45)`, opacity: 0.95, offset: 0.6 },
        { transform: `translate(${dx}px, ${dy}px) scale(0.08)`, opacity: 0.15 },
      ],
      { duration: 750, easing: 'cubic-bezier(0.65,0,0.35,1)' }
    );
    anim.onfinish = () => ghost.remove();
    anim.oncancel = () => ghost.remove();
  } catch (e) {
    if (process.env.NODE_ENV !== 'production') console.debug('flyToCart skipped', e);
  }
}
